import { render, staticRenderFns } from "./FeeComparisonView.vue?vue&type=template&id=3719dd12&scoped=true"
import script from "./FeeComparisonView.vue?vue&type=script&lang=ts"
export * from "./FeeComparisonView.vue?vue&type=script&lang=ts"
import style0 from "./FeeComparisonView.vue?vue&type=style&index=0&id=3719dd12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3719dd12",
  null
  
)

export default component.exports